import { render, staticRenderFns } from "./JobListingCandidateComments.vue?vue&type=template&id=f2011d82"
import script from "./JobListingCandidateComments.vue?vue&type=script&lang=js"
export * from "./JobListingCandidateComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2011d82')) {
      api.createRecord('f2011d82', component.options)
    } else {
      api.reload('f2011d82', component.options)
    }
    module.hot.accept("./JobListingCandidateComments.vue?vue&type=template&id=f2011d82", function () {
      api.rerender('f2011d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/JobListingCandidateComments.vue"
export default component.exports